import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { AthleteContext } from "./App";

export default function TopNav() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const path = location.pathname;
  const [topMenuItems, setTopMenuItems] = useState([]);
  const { currentAthlete } = useContext(AthleteContext);
  const menuRef = useRef(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/menu-items/top-menu`)
      .then(res => res.json())
      .then(data => setTopMenuItems(data))
      .catch(console.error);
  }, []);

  // TODO: click-outside for mobile menu and filter menu not yet working —
  // menu visibility is controlled via DOM (style.display) rather than React state,
  // so menuOpen state and actual visibility can diverge. Needs a refactor.
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    if (menuOpen) document.addEventListener("mousedown", handleClickOutside);
    else document.removeEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [menuOpen]);

  const makeHref = (item) => item.url || `/content/${item.code}`;
  const isActive = (target) => path === target ? "active-link" : "";

  return (
    <>
      <nav className="mobile-menu" id="mobileMenu" ref={menuRef}>
        <button
          className="menu-close"
          onClick={() => toggleMobileMenu()}
          aria-label="Close menu"
        >
          ×
        </button>
        <a href="/" className={isActive("/")}>Home</a>
        {currentAthlete ? (
          <a href="/onboarding" className={isActive("/onboarding")}>Mijn profiel</a>
        ) : (
          <a href="/aanmelden" className={isActive("/aanmelden")}>Aanmelden</a>
        )}
        {topMenuItems.map(item => (
          <a key={`mobile-menu-${item.code}`} href={makeHref(item)}>
            {item.title}
          </a>
        ))}
      </nav>
    </>
  );
}